import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.common.ResourceLock.';
  public static readonly lockFailedCouldNotBeLocked = `${Id.prefix}lockFailedCouldNotBeLocked`;
  public static readonly resourceLockFailed = `${Id.prefix}resourceLockFailed`;
  public static readonly lockAbandonedBrowserAsleep = `${Id.prefix}lockAbandonedBrowserAsleep`;
  public static readonly lockFailedErrorReacquiring = `${Id.prefix}lockFailedErrorReacquiring`;
  public static readonly lockFailedTakenByAnother = `${Id.prefix}lockFailedTakenByAnother`;
  public static readonly lockDataModifiedWhileOffline = `${Id.prefix}lockDataModifiedWhileOffline`;
  public static readonly lockConcurrencyCheckFailed = `${Id.prefix}lockConcurrencyCheckFailed`;
}

export class LangResourceLock {
  private constructor() {}
  public static lockFailedCouldNotBeLocked(params: { resource: string }): string {
    return interpolate(Id.lockFailedCouldNotBeLocked, params);
  }
  public static resourceLockFailed(): string {
    return interpolate(Id.resourceLockFailed);
  }
  public static lockAbandonedBrowserAsleep(params: { resource: string }): string {
    return interpolate(Id.lockAbandonedBrowserAsleep, params);
  }
  public static lockFailedErrorReacquiring(params: { resource: string }): string {
    return interpolate(Id.lockFailedErrorReacquiring, params);
  }
  public static lockFailedTakenByAnother(params: { resource: string; user: string }): string {
    return interpolate(Id.lockFailedTakenByAnother, params);
  }
  public static lockDataModifiedWhileOffline(params: { resource: string }): string {
    return interpolate(Id.lockDataModifiedWhileOffline, params);
  }
  public static lockConcurrencyCheckFailed(params: { resource: string }): string {
    return interpolate(Id.lockConcurrencyCheckFailed, params);
  }
}

export class ResourceLockModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.lockFailedCouldNotBeLocked,
      'The {{resource}} could not be locked at this time, due to a communication error.',
      'Error message when resource could not be locked'
    );
    register.add(Id.resourceLockFailed, 'Resource Lock Failed', 'Dialog title for resource lock failure');
    register.add(
      Id.lockAbandonedBrowserAsleep,
      'This browser has been asleep from lack of use, or without internet connectivity, and the {{resource}} will be abandoned now as it may have been changed by other users. Please reopen to make edits.',
      'Message when browser sleep causes lock to be abandoned'
    );
    register.add(
      Id.lockFailedErrorReacquiring,
      'There was an error reacquiring the lock on this {{resource}}. Please attempt to close and save now to avoid data loss.',
      'Message when error reacquiring lock'
    );
    register.add(
      Id.lockFailedTakenByAnother,
      'We attempted to maintain the lock on this {{resource}}, but a lock has been issued to {{user}}.  Due to this we needed to abandon changes and close the {{resource}} now. you can try to reopen it, if the other user unlocks it.',
      'Message when lock is taken by another user'
    );
    register.add(
      Id.lockDataModifiedWhileOffline,
      'Your {{resource}} was modified by another user while you were disconnected. Your unsaved changes cannot be applied. The {{resource}} will be closed.',
      'Message when data was modified while user was offline'
    );
    register.add(
      Id.lockConcurrencyCheckFailed,
      'Unable to verify your {{resource}} data after reconnection. Please reload to ensure you have the latest version.',
      'Message when concurrency check fails'
    );
  }
}
